// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fetchingLoader__ab9 {
  height: var(--ring-line-height);
  padding: var(--ring-border-radius);
  display: flex;
  align-items: center;
  justify-content: center;
}

.filtersContainer__a2b {
  margin-top: calc(var(--ring-unit) * 2);
}
`, "",{"version":3,"sources":["webpack://./src/pages/plugins/plugin-page/filters/plugin-version-filters.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":[".fetchingLoader {\n  height: var(--ring-line-height);\n  padding: var(--ring-border-radius);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.filtersContainer {\n  margin-top: calc(var(--ring-unit) * 2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fetchingLoader": `fetchingLoader__ab9`,
	"filtersContainer": `filtersContainer__a2b`
};
export default ___CSS_LOADER_EXPORT___;
